package com.havn.app.features.leads.domain

import androidx.paging.PagingData
import com.havn.app.features.openhouses.domain.LeadTemperature
import kotlinx.coroutines.flow.Flow

interface LeadRepository {
    suspend fun leadsForAgent(agentId: String, agencyId: String? = null): Result<List<Lead>>
    suspend fun leadPage(agentId: String, agencyId: String? = null, query: String = "", offset: Int = 0, limit: Int = 50): Result<List<Lead>>
    fun pagedLeadsForAgent(agentId: String, agencyId: String? = null): Flow<PagingData<Lead>>
    suspend fun leadDetail(agentId: String, leadId: String): Result<Lead>
    suspend fun updateLeadTemperature(
        agentId: String,
        leadId: String,
        temperature: LeadTemperature
    ): Result<Unit>

    suspend fun updateLeadNotes(
        agentId: String,
        leadId: String,
        notes: String
    ): Result<Lead>
}
